import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-list',
  styleUrl: 'signet-list.scss',
  shadow: true,
})
export class SignetList {
  render() {
    return (
      <div class="signet-list-container">
        <slot></slot>
      </div>
    );
  }
}
